import apiUrl from '../../../constants';
import axios from 'axios';
import iptrackerdetails from '../../../iptrackerdetails'
import Paginate from 'vuejs-paginate';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate';
import VueElementLoading from 'vue-element-loading';

// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  name: 'projectmaster',
  components: {
    Paginate,
    VueElementLoading
  },
  data: function() {
    return {
      modalShow: false,
      updateusermodal: false,
      editusermodal: false,
      addusermodal: false,
      useraction: '',
      projectname: '',
      iptrackData:'',
      searchprojectname: (window.localStorage.getItem("LSProjectName")) ? (window.localStorage.getItem("LSProjectName")) : "",
      listProjectData: [],
      is_active:'',
      appkey : '',
      appurl : '',
      apiurl : '',
      IsMobileApp : '',
      tokenexpiry : '',
      props: [],
      pageno: 0,
      pagecount: 0,
      projectid: 0,
      isLoading: false,
      resultCount: '',
      count: 0,
      localuserid: 0,
    }
  },
  created: function() {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail');
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.iptrackData = userdetail
    this.localuserid = userdetail.userid;
    this.localusername = userdetail.username;
    this.getProjectData();
  },
  methods: {
    addNewProject() {
      this.projectid = '';
      this.projectname = '';
      this.appkey = '';
      this.appurl = '';
      this.apiurl = '';
      this.IsMobileApp = false,
      this.tokenexpiry = '';
      this.is_active = 'true';
      this.useraction = 'add',
      this.addusermodal = true,
      this.$validator.reset();
      this.errors.clear();
    },
    closeProjectModel() {
      $("#projectform").trigger("reset");
      this.addusermodal = false,
      this.$validator.reset();
      this.errors.clear();
    },

    getProjectData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      window.localStorage.setItem("LSProjectName",this.searchprojectname)
      this.input = ({
        offset: this.pageno,
        limit: 10,
        projectname: this.searchprojectname
      })
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getproject',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }

        })
        .then(result => {
          this.listProjectData = result.data.data.rows;
          this.isLoading = false;
          let totalRows = result.data.data.count
          this.resultCount = result.data.data.count
          this.pageno = 0;if (totalRows < 10) {
            this.pagecount = 1
          } else {
            this.pagecount = Math.ceil(totalRows / 10)
          }
        }, error => {
          console.error(error)
        })
    },

    saveProject(event) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
        this.input = ({
          projectname: this.projectname.trim(),
          appkey: this.appkey.trim(),
          appurl: this.appurl,
          apiurl: this.apiurl,
          is_active: this.is_active,
          IsMobileApp: this.IsMobileApp,
          tokenexpiry: this.tokenexpiry!=''? this.tokenexpiry: null,
          createdby:this.localusername
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url + 'saveproject',
            'data': this.input,
            headers: {
              'Authorization': 'Bearer ' + myStr
            }
          })
          .then((response) => {
            if (response.data.errorCode == 0) {
              this.$alertify.success(response.data.msg);
              this.addusermodal = false;
              event.target.reset();
              this.resetForm();
            } else if (response.data.errorCode == -1) {
              this.$alertify.error(response.data.msg)
            }

            iptrackerdetails.checkUserIP(this.iptrackData,'Save project master',this.$route.path,this.input,response.data);
          })
          .catch((httpException) => {
            console.error('exception is:::::::::', httpException)
          })
    },
    searchProjectData(){
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      this.getProjectData();
    },
    getProjectDatabySearch() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = ({
        offset: this.pageno,
        limit: 10,
        projectname: this.searchprojectname
      })
      this.isLoading = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'searchproject',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.listProjectData = result.data.rows;
          this.isLoading = false;
          let totalRows = result.data.count
          this.resultCount = result.data.count
          if (totalRows < 10) {
            this.pagecount = 1
          } else {
            this.pagecount = Math.ceil(totalRows / 10)
          }
        }, error => {
          console.error(error)
        })
    },

    getProjectRowData(data) {
      this.$validator.reset();
      this.errors.clear();
      this.useraction = 'edit';
      this.addusermodal = true;
      this.projectname = data.projectname;
      this.projectid = data.projectid;
      this.is_active = data.is_active;
      this.appkey = data.appkey;
      this.appurl = data.appurl;
      this.apiurl = data.apiurl;
      this.IsMobileApp = data.IsMobileApp;
      this.tokenexpiry = data.tokenexpiry;
    },

    editProject(event) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({
        projectid: this.projectid,
        projectname: this.projectname,
        is_active: this.is_active,
        appkey: this.appkey,
        appurl: this.appurl,
        apiurl: this.apiurl,
        IsMobileApp: this.IsMobileApp,
        tokenexpiry: this.tokenexpiry!=''? this.tokenexpiry: null,
        modifiedby:this.localusername
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'updateproject',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then((response) => {
          if (response.data.errorCode == 0) {
            this.$alertify.success(response.data.msg);
            this.addusermodal = false;
            event.target.reset();
            this.resetForm();
          } else if (response.data.errorCode == -1) {
            this.$alertify.error(response.data.msg)
          }
          iptrackerdetails.checkUserIP(this.iptrackData,'update project master',this.$route.path,this.input,response.data);

        })
        .catch((httpException) => {
          console.error('exception is:::::::::', httpException)
        })
    },

    //to get pagination
    getPaginationData(pageNum) {
      this.pageno = (pageNum - 1) * 10
      this.getProjectData()
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if(result){
          if(this.projectid!=undefined && this.projectid!=""){
            this.editProject(event);
          }else{
            this.saveProject(event);
          }
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    resetSearch(){
      this.searchprojectname = '';
      this.pageno = 0;
      this.$refs.paginate.selected = 0;
      window.localStorage.removeItem("LSProjectName")
      this.getProjectData();
    },
    resetForm() {
      this.projectid = '';
      this.projectname = '';
      this.appkey = '';
      this.appurl = '';
      this.apiurl = '';
      this.IsMobileApp = false;
      this.tokenexpiry = '';
      this.is_active = '';
      this.useraction = 'add';
      this.$validator.reset();
      this.errors.clear();
      this.getProjectData();
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/projectmaster/projectmaster.component.js